<div class="date-picker-popup-content" (click)="$event.stopPropagation()">
  <!-- Left Side Panel -->
  <div
    class="left-side saas-ui saas-ui-size-default"
    [class.compare]="compareToggledOn">
    <!-- Content (top section) -->
    <div class="left-side-content">
      <!-- Title -->
      <div class="date-picker-title">
        <span class="sh2 text-gray-1000">Date Presets</span>
      </div>

      <!-- Info Bar -->
      <div class="date-picker-info-bar">
        <i
          class="material-symbols-outlined icon-small text-gray-500"
          aria-hidden="true">
          info
        </i>
        <span class="c1 text-gray-800">{{ availabilityInfoText }}</span>
      </div>

      <!-- Range Picker: Preset Dropdown + Date Inputs -->
      <div class="range-picker-section">
        <m-dropdown
          class="preset-dropdown"
          width="100%"
          panelStyleClass="fiscal-preset-panel"
          [options]="datePresetOptions"
          [(ngModel)]="selectedDatePreset"
          (onChange)="onDatePresetChange($event.value)"
          optionLabel="label"
          optionValue="value"
          placeholder="Select preset">
        </m-dropdown>
        <div class="date-inputs-row">
          <input
            pInputText
            type="text"
            class="date-input"
            [value]="displayDates().start"
            (focus)="onInputFocus($event, 'startDate')"
            (blur)="onInputBlur($event, 'startDate')"
            (change)="onInputChange($event, 'startDate')" />
          <span class="b1 text-gray-1000">-</span>
          <input
            pInputText
            type="text"
            class="date-input"
            [value]="displayDates().end"
            (focus)="onInputFocus($event, 'endDate')"
            (blur)="onInputBlur($event, 'endDate')"
            (change)="onInputChange($event, 'endDate')" />
        </div>
      </div>

      <!-- Compare Section -->
      @if (compareEnabled) {
        <div class="compare-section" [class.compare]="compareToggledOn">
          <div class="input-switch">
            <label for="compareSwitch">
              <m-switch
                id="compareSwitch"
                class="compare-toggle"
                [(ngModel)]="compareToggledOn"
                (onChange)="onCompareToggle($event.checked)">
              </m-switch>
              <span class="toggle-text">Compare with</span>
            </label>
          </div>
          @if (compareToggledOn) {
            <!-- Compare Preset Dropdown -->
            <div class="preset-section">
              <m-dropdown
                class="preset-dropdown"
                width="100%"
                panelStyleClass="fiscal-preset-panel"
                [options]="comparePresetOptions"
                [(ngModel)]="selectedComparePreset"
                (onChange)="onComparePresetChange($event.value)"
                optionLabel="label"
                optionValue="value"
                placeholder="Select preset">
              </m-dropdown>
            </div>

            <div class="date-inputs-row">
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevStart"
                (focus)="onInputFocus($event, 'startDateCompare')"
                (blur)="onInputBlur($event, 'startDateCompare')"
                (change)="onInputChange($event, 'startDateCompare')" />
              <span class="b1 text-gray-1000">-</span>
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevEnd"
                (focus)="onInputFocus($event, 'endDateCompare')"
                (blur)="onInputBlur($event, 'endDateCompare')"
                (change)="onInputChange($event, 'endDateCompare')" />
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="date-picker-footer d-flex gap-3 mt-auto">
      <m-button
        type="primary"
        label="Save"
        [disabled]="isApplyButtonDisabled"
        (click)="apply()"></m-button>
      <m-button type="secondary" label="Cancel" (click)="cancel()"></m-button>
    </div>
  </div>

  <!-- Right Side - Fiscal Calendar -->
  <div class="calendar-side fiscal" [class.compare]="compareToggledOn">
    <m-fiscal-calendar
      [months]="months()"
      [startDate]="calendarDates().start"
      [endDate]="calendarDates().end"
      [previousStartDate]="
        compareToggledOn ? calendarDates().compareStart : null
      "
      [previousEndDate]="compareToggledOn ? calendarDates().compareEnd : null"
      [minDate]="formattedMinDate()"
      [maxDate]="formattedMaxDate()"
      (selectedDateRange)="onFiscalDateSelected($event)">
    </m-fiscal-calendar>
  </div>
</div>
